export const convertPathToImageUrl = (path: string) => {
    return `https://cdn-v2.kidsplaza.vn/${path}`;
};
